/* PureX Labs theme JS */
(function () {
  'use strict';

  /* Nav drawer */
  var drawer = document.getElementById('NavDrawer');
  var openBtn = document.getElementById('NavOpen');
  var closeBtn = document.getElementById('NavClose');
  if (drawer && openBtn) {
    var setDrawer = function (open) {
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    openBtn.addEventListener('click', function () { setDrawer(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
    var scrim = drawer.querySelector('.nav-drawer__scrim');
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* Search toggle */
  var searchBar = document.getElementById('SearchBar');
  var searchToggle = document.getElementById('SearchToggle');
  if (searchBar && searchToggle) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* Product tabs */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('.product-tabs__nav button');
    var panels = tabs.querySelectorAll('.product-tabs__panel');
    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main img');
    gallery.querySelectorAll('.product-thumbs img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.dataset.full || thumb.src;
      });
    });
  });

  /* Variant picker: swap price + form variant id + availability */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = wrap.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var addBtn = wrap.querySelector('[data-add-btn]');
    var money = function (cents) {
      return (dataEl.dataset.currency || '$') + (cents / 100).toFixed(2);
    };
    wrap.querySelectorAll('.variant-pills input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === radio.value; });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        wrap.querySelectorAll('.bulk-tier__price[data-pct]').forEach(function (el) {
          var pct = parseFloat(el.dataset.pct) || 0;
          el.textContent = money(Math.floor(v.price * (100 - pct) / 100)) + ' each';
        });
        var fbtThisInput = document.querySelector('[data-fbt-this-input]');
        var fbtThisPrice = document.querySelector('[data-fbt-this-price]');
        if (fbtThisInput) { fbtThisInput.value = v.id; fbtThisInput.dataset.price = v.price; }
        if (fbtThisPrice) { fbtThisPrice.textContent = money(v.price); }
        var totalEl = document.querySelector('[data-product-total]');
        if (totalEl) totalEl.dataset.unitPrice = v.price;
        var creditEl = document.querySelector('[data-credit]');
        if (creditEl) creditEl.dataset.unitPrice = v.price;
        document.dispatchEvent(new CustomEvent('fbt:refresh'));
        document.dispatchEvent(new CustomEvent('purex:recalc'));
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold;
        }
      });
    });
  });

  /* Frequently bought together: live total + add all to cart */
  document.querySelectorAll('[data-fbt]').forEach(function (fbt) {
    var currency = fbt.dataset.currency || '$';
    var money = function (cents) { return currency + (cents / 100).toFixed(2); };
    var totalEl = fbt.querySelector('[data-fbt-total]');
    var countEls = fbt.querySelectorAll('[data-fbt-count]');
    var addBtn = fbt.querySelector('[data-fbt-add]');

    var included = function (item) {
      if (item.hasAttribute('data-required')) return true;
      return item.type === 'checkbox' && item.checked && !item.disabled;
    };
    var update = function () {
      var total = 0, count = 0;
      fbt.querySelectorAll('[data-fbt-item]').forEach(function (item) {
        if (included(item)) { total += parseInt(item.dataset.price, 10) || 0; count += 1; }
      });
      if (totalEl) totalEl.textContent = money(total);
      countEls.forEach(function (el) { el.textContent = count; });
      if (addBtn) addBtn.disabled = count === 0;
    };

    fbt.querySelectorAll('.fbt__check').forEach(function (cb) {
      cb.addEventListener('change', update);
    });
    document.addEventListener('fbt:refresh', update);
    update();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        fbt.querySelectorAll('[data-fbt-item]').forEach(function (item) {
          if (included(item) && item.value) items.push({ id: item.value, quantity: 1 });
        });
        if (!items.length) return;
        var original = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
          if (window.PureXCart) { window.PureXCart.open(); }
          else { window.location.href = '/cart'; }
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.innerHTML = original;
        });
      });
    }
  });

  /* Bulk pricing tiers: click to set quantity + highlight active tier */
  document.querySelectorAll('[data-bulk-grid]').forEach(function (grid) {
    var qtyInput = document.querySelector('[data-product-form] input[name="quantity"]');
    var tiers = grid.querySelectorAll('.bulk-tier');
    var markSelected = function () {
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var best = -1;
      tiers.forEach(function (t) {
        var tq = parseInt(t.dataset.bulkQty, 10) || 0;
        if (q >= tq && tq > best) best = tq;
      });
      tiers.forEach(function (t) {
        var on = (parseInt(t.dataset.bulkQty, 10) || 0) === best;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (qtyInput) {
          qtyInput.value = t.dataset.bulkQty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        markSelected();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', markSelected);
      qtyInput.addEventListener('change', markSelected);
    }
    markSelected();
  });

  /* Product buy box: quantity stepper, running total, store credit */
  (function () {
    var qtyInput = document.querySelector('[data-product-form] [data-qty-input]');
    if (!qtyInput) return;
    var dataEl = document.querySelector('[data-variant-json]');
    var currency = (dataEl && dataEl.dataset.currency) || '$';
    var money = function (c) { return currency + (c / 100).toFixed(2); };
    var totalEl = document.querySelector('[data-product-total]');
    var creditEl = document.querySelector('[data-credit]');
    var recalc = function () {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (totalEl) totalEl.textContent = money((parseInt(totalEl.dataset.unitPrice, 10) || 0) * qty);
      if (creditEl) creditEl.textContent = 'Earn ' + money(Math.round((parseInt(creditEl.dataset.unitPrice, 10) || 0) * qty * 5 / 100)) + ' back in store credit';
    };
    document.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        recalc();
      });
    });
    qtyInput.addEventListener('input', recalc);
    qtyInput.addEventListener('change', recalc);
    document.addEventListener('purex:recalc', recalc);
    recalc();

    document.querySelectorAll('[data-share]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (navigator.share) { navigator.share({ title: document.title, url: location.href }).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(location.href); }
      });
    });
    document.querySelectorAll('[data-save]').forEach(function (b) {
      b.addEventListener('click', function () { b.classList.toggle('is-saved'); });
    });
  })();

  /* Slide-out cart drawer with free-shipping bar + upsell */
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var currency = drawer.dataset.currency || '$';
    var threshold = parseInt(drawer.dataset.threshold, 10) || 0;
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var upsellEl = drawer.querySelector('[data-upsell]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var bubbleEls = document.querySelectorAll('[data-cart-bubble]');
    var shipMsg = drawer.querySelector('[data-ship-msg]');
    var shipFill = drawer.querySelector('[data-ship-fill]');
    var busy = false;

    var money = function (c) { return currency + (c / 100).toFixed(2); };
    var open = function () { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refresh(); };
    var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };

    var itemHTML = function (item) {
      var img = item.image ? '<img class="cd-item__img" src="' + item.image + '" alt="" width="64" height="64">' : '<span class="cd-item__img"></span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cd-item__variant">' + item.variant_title + '</span>' : '';
      return '<div class="cd-item" data-line="' + item.key + '">' + img +
        '<div class="cd-item__main">' +
        '<a class="cd-item__title" href="' + item.url + '">' + item.product_title + '</a>' + variant +
        '<div class="cd-item__row">' +
        '<div class="cd-stepper">' +
        '<button type="button" data-step="-1" aria-label="Decrease">−</button>' +
        '<input type="number" min="0" value="' + item.quantity + '" data-line-qty aria-label="Quantity">' +
        '<button type="button" data-step="1" aria-label="Increase">+</button>' +
        '</div>' +
        '<span class="cd-item__price">' + money(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="cd-item__remove" data-line-remove>Remove</button>' +
        '</div></div>';
    };

    var render = function (cart) {
      var count = cart.item_count;
      countEls.forEach(function (el) { el.textContent = count; });
      bubbleEls.forEach(function (el) { el.hidden = count === 0; el.textContent = count; });
      if (subEl) subEl.textContent = money(cart.total_price);

      if (count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footEl) footEl.hidden = true;
        if (upsellEl) upsellEl.hidden = true;
      } else {
        if (emptyEl) emptyEl.hidden = true;
        if (footEl) footEl.hidden = false;
        itemsEl.innerHTML = cart.items.map(itemHTML).join('');
      }

      if (threshold > 0 && shipFill && shipMsg) {
        var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
        shipFill.style.width = pct + '%';
        if (cart.total_price >= threshold) {
          shipMsg.innerHTML = '✓ Free express shipping unlocked';
        } else {
          shipMsg.innerHTML = 'Add <b>' + money(threshold - cart.total_price) + '</b> for free express shipping';
        }
      }

      if (upsellEl && count > 0) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });
        var shown = 0;
        upsellEl.querySelectorAll('[data-upsell-item]').forEach(function (card) {
          var hide = inCart[card.dataset.pid] || shown >= 3;
          card.hidden = hide;
          if (!hide) shown += 1;
        });
        upsellEl.hidden = shown === 0;
      }
    };

    var refresh = function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    };

    var change = function (line, qty) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(render)
        .finally(function () { busy = false; });
    };

    var addVariant = function (id, btn) {
      if (busy) return;
      busy = true;
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.ok ? refresh() : null; })
        .finally(function () { busy = false; if (btn) btn.disabled = false; });
    };

    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { if (el.hasAttribute('href')) e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cd-item');
      if (!row) return;
      var line = row.dataset.line;
      var input = row.querySelector('[data-line-qty]');
      if (e.target.matches('[data-step]')) {
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(e.target.dataset.step, 10));
        change(line, next);
      } else if (e.target.matches('[data-line-remove]')) {
        change(line, 0);
      }
    });
    itemsEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-line-qty]')) {
        var row = e.target.closest('.cd-item');
        change(row.dataset.line, Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });

    if (upsellEl) {
      upsellEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-upsell-add]');
        if (btn) addVariant(btn.dataset.variantId, btn);
      });
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"], [name="add"]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.ok ? refresh() : null; })
          .then(function () { open(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });

    window.PureXCart = { open: open, close: close, refresh: refresh };
  })();

  /* Lab results: search filter + COA lightbox */
  (function () {
    var grid = document.querySelector('[data-lab-grid]');
    var search = document.querySelector('[data-lab-search]');
    if (grid && search) {
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-lab-item]'));
      var countEl = document.querySelector('[data-lab-count]');
      var emptyEl = document.querySelector('[data-lab-empty]');
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var shown = 0;
        items.forEach(function (it) {
          var match = !q || (it.getAttribute('data-name') || '').indexOf(q) !== -1;
          it.hidden = !match;
          if (match) shown++;
        });
        if (countEl) countEl.textContent = shown;
        if (emptyEl) emptyEl.hidden = shown !== 0;
      });
    }

    var box = document.querySelector('[data-coa-lightbox]');
    if (box) {
      var boxImg = box.querySelector('[data-coa-lightbox-img]');
      var boxTitle = box.querySelector('[data-coa-lightbox-title]');
      var openLb = function (full, title) {
        boxImg.src = full;
        boxImg.alt = 'Certificate of Analysis — ' + title;
        if (boxTitle) boxTitle.textContent = title;
        box.classList.add('is-open');
        box.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };
      var closeLb = function () {
        box.classList.remove('is-open');
        box.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        boxImg.src = '';
      };
      document.querySelectorAll('[data-coa-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openLb(btn.getAttribute('data-coa-full'), btn.getAttribute('data-coa-title') || 'COA');
        });
      });
      box.querySelectorAll('[data-coa-close]').forEach(function (el) {
        el.addEventListener('click', closeLb);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && box.classList.contains('is-open')) closeLb();
      });
    }
  })();
})();
